import React, { useEffect, useRef, useState, useContext, createContext } from 'react';
import { Button, Form, Input, Row, Col, message, MainModal, useProTableOt, ProTableOt, } from "../ui/ot";
import dayjs from 'dayjs';
import { useNavigate, } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from "@ant-design/icons";
import { useHoliday } from './controller/use_holiday_controller';
const LanguageContext = createContext(null)

const HolidayOverView = ({
    keyPrefix = "shift_management.holiday_overview",
    propsForm,
    customColumns = [],
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    rowKey = "holiday_setting_id",
    propsHolidaySettingApi = "/shift_management/api/holiday/setting",
    propsSearchparams
}
) => {
    const { t } = useTranslation("translation", { keyPrefix });
    const navigate = useNavigate();
    const actionRef = useRef()
    const [extra_columns, set_extra_columns] = useState([]);
    const [loading, set_loading] = useState(0);
    const [pageSize, setPageSize] = useState(20)
    const [columns, setColumns] = useState([
        {
            title: `${t('holiday_setting_year')}`,
            key: 'holiday_setting_year',
            dataIndex: 'holiday_setting_year',
            align: 'center',
            sorter: false,
        },
        {
            title: `${t('all_holiday_count')}`,
            key: 'all_holiday_count',
            dataIndex: 'all_holiday_count',
            sorter: false,
            align: 'center',
            render: (text, record, index) => {
                return (
                    <>
                        {text ?? 0}/365
                    </>
                )
            }
        },
        ...customColumns,
        {
            title: `${t('action')}`,
            key: 'action',
            dataIndex: 'action',
            align: 'center',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                return <Row justify={'center'}>
                    <Col>
                        <Button
                            variant={"ghost"}
                            className="text-blue-600 p-2"
                            onClick={() => {
                                navigate(`./detail?holiday_setting_id=${record?.holiday_setting_id}`)
                            }}
                        >
                            詳細
                        </Button>
                    </Col>
                </Row>
            }
        },

    ]);

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [axiosMode, setAxiosMode] = useState("get")
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const reload = () => {
        actionRef.current.reloadAndRest();
    }

    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                getHolidaySettingData()
                reload()
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                reload()
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                reload()
                // setSelectedRowsInfo([])
            }
            else if (axiosMode === "get") {
                set_loading(false)
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                reload()
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                reload()
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                reload()
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }

    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const newSystemHolidaySetting = () => {
        let lastYear = dayjs().subtract(1, 'year').format("YYYY")
        if (!!HolidaySettingNewYearDatas?.year) {
            if (HolidaySettingNewYearDatas?.year < 2000) {
                getHolidaySettingData(
                    [
                        {
                            year: lastYear
                        }
                    ]
                )
            }
            else {
                getHolidaySettingData(
                    [
                        {
                            year: HolidaySettingNewYearDatas?.year
                        }
                    ]
                )
            }
        }
    }

    const useTableColumnsCheck = (columns) => {
        const [check, setCheck] = useState([])
        const checkAll = () => {
            setCheck((pre) => {
                return columns
                    .filter((element) => !element.disabled)
                    .map((val) => val.key);
            });
        }
        const setOrders = (sorter) => {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        return {
            check,
            custom_filter_key: check,
            setCheck,
            checkAll,
            setOrders
        }
    }

    const onFormFinish = (e) => {
        postHolidaySettingData([e])
    }

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getHolidaySettingNewYear()
    }

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)

    const {
        HolidaySettingNewYearDatas,
        getHolidaySettingNewYear,
        getHolidaySettingData,
        postHolidaySettingData,
        deleteHolidaySettingData
    } = useHoliday({
        mainApi: propsHolidaySettingApi,
        onBefore: () => { },
        onFinish: onFinish
    })

    useEffect(() => {
        setDataInitialization()
        checkAll()
    }, []);
    return (
        <Row gutter={[8, 8]}>
            <MainModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                propsForm={form}
                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}
                onFinish={onFormFinish}
                formElement={<HolidayForm holidaySettingNewYearDatas={HolidaySettingNewYearDatas} />}
            />
            <Col span={24}>
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <ProTableOt
                            searchParams={
                                {
                                    ...propsSearchparams
                                }
                            }
                            actionRef={actionRef}
                            columns={columns}
                            check={check}
                            setCheck={setCheck}
                            rowKey={'holiday_setting_id'}
                            selections={{
                                // onChange: (index_, data_) => set_data(data_)
                            }}
                            toolBarRender={() => [
                                <Button
                                    icon={<PlusOutlined />}
                                    variant={"default"}
                                    onClick={handleAddRow}>
                                    新增年份
                                </Button>
                            ]}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            manage_columns={false}
                            request={async (params = {}, sort, filter) => {
                                setAxiosMode("get")
                                let newParams = {
                                    ...propsSearchparams
                                };
                                let order = setOrders(sort)
                                newParams = {
                                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                    ...newParams,
                                    order,
                                    size: params.pageSize,
                                    cur_page: params.current,
                                    custom_filter_value: params.keyword ?? "",
                                    custom_filter_key: custom_filter_key
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                setPageSize(params?.pageSize ?? 20)
                                return getHolidaySettingData(newParams)
                            }}
                            pageSize={pageSize}
                            scroll={{
                                x: "max-content"
                            }}
                            rowSelection={false}
                        // rowSelection={{
                        //     type: 'checkbox',
                        //     selectedRowKeys:  selectedRowKeys  ,
                        //     selectedRowsInfo:   selectedRowsInfo ,
                        //     setSelectedRowKeys: setSelectedRowKeys,
                        //     setSelectedRowsInfo: setSelectedRowsInfo,
                        //     ...rowSelection,
                        // }}
                        // propsDelete ={true}
                        // propsUseData={() => {
                        //     return {
                        //         deleteData: (data)=>{
                        //             console.log({
                        //                 data
                        //             })
                        //             deleteHolidaySettingData(data)
                        //         }
                        //     }
                        // }}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}



const HolidayForm = ({
    keyPrefix = "shift_management.holiday_overview",
    propsForm,
    formReloadCount = 0,
    holidaySettingNewYearDatas = null,
    onValuesChange = () => { },
    onFormFinish = () => { },
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [form] = Form.useForm();
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    useEffect(() => {
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])
    useEffect(() => {
        if (holidaySettingNewYearDatas) {
            if (propsForm) {
                propsForm.setFieldsValue(holidaySettingNewYearDatas)
            }
            else {
                form.setFieldsValue(holidaySettingNewYearDatas)
            }
        }
    }, [holidaySettingNewYearDatas])

    return (
        <>
            <Row>
                <Col span={24}>
                    <Form
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        layout="horizontal"
                        form={propsForm ? propsForm : form}
                        onValuesChange={onValuesChange}
                        onFinish={onFinish}
                        autoComplete="off"
                    >
                        {propsForm && propsForm.getFieldsValue('total') !== 0 ?
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Form.Item
                                        name="year"
                                        label={t('input_year')}
                                    >
                                        <Input disabled={true} />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        name="total"
                                        label={t('total_public_holiday')}
                                    >
                                        <Input disabled={true} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            :
                            <Row gutter={[8, 8]}>
                                <Col span={24}>

                                    <Form.Item
                                        name="year"
                                        label={t('no_total_public_holiday')}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                    </Form>
                </Col>
            </Row>
        </>
    )
}
export default HolidayOverView;